<template>
  <div class="q-mx-auto q-py-sm" style="max-width: 900px">
    <div class="row">
      <div
        class="q-pa-sm"
        :class="tableRightData.length ? 'col-md-7 col-12' : 'col-12'"
      >
        <p
          class="text-subtitle2 text-bold"
          :class="this.$q.dark.mode === true ? '' : 'text-primary '"
        >
          Dividends History of {{ symbol }}
        </p>
        <q-table
          class="q-my-md"
          :class="
            this.$q.dark.mode === true
              ? 'table-sticky-header-column-dark'
              : 'table-sticky-header-column'
          "
          :rows="tableBonusData"
          :columns="columnsBonus"
          :pagination="pagination"
          separator="cell"
        />
      </div>
      <div
        class="q-pa-sm"
        :class="tableRightData.length ? 'col-md-5 col-12' : 'col-12'"
      >
        <div v-if="tableRightData.length">
          <p
            class="text-subtitle2 text-bold"
            :class="this.$q.dark.mode === true ? '' : 'text-primary '"
          >
            Right Share of {{ symbol }}
          </p>
          <q-table
            class="q-my-md"
            :class="
              this.$q.dark.mode === true
                ? 'table-sticky-header-column-dark'
                : 'table-sticky-header-column'
            "
            :rows="tableRightData"
            :columns="columnsRight"
            :pagination="pagination"
            separator="cell"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted, watch } from "vue";
import useCore from "src/use/core";

export default {
  name: "StockDividends",

  props: {
    symbol: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const { bonus, right } = useCore();

    const bonusData = ref([]);
    const tableBonusData = ref([]);
    const tableRightData = ref([]);

    const getBonusData = (symbol) => {
      bonus(symbol).then((res) => {
        tableBonusData.value = res.data;
      });
      right(symbol).then((res) => {
        tableRightData.value = res.data;
      });
    };

    const columnsBonus = [
      {
        name: "symbol",
        label: "Symbol",
        field: "symbol",
        align: "left",
      },
      {
        name: "year",
        label: "Year",
        field: "year",
        align: "center",
      },
      {
        name: "bonus",
        label: "Bonus",
        field: "bonus",
        format: (val, row) => {
          return val ? parseFloat(val).toFixed(2) : "-";
        },
        align: "center",
      },
      {
        name: "cash",
        label: "Cash",
        field: "cash",
        format: (val, row) => {
          return val ? parseFloat(val).toFixed(2) : "-";
        },
        align: "center",
      },
      {
        name: "total",
        label: "Total",
        field: "total",
        format: (val, row) => {
          return val ? parseFloat(val).toFixed(2) : "-";
        },
        align: "center",
      },
      {
        name: "book_close_date",
        label: "Book Close Date",
        field: "book_close_date",
        align: "center",
      },
    ];
    const columnsRight = [
      {
        name: "symbol",
        label: "Symbol",
        field: "symbol",
        align: "left",
      },
      {
        name: "year",
        label: "Year",
        field: "year",
        align: "center",
      },
      {
        name: "right",
        label: "Right",
        field: "right",
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        align: "center",
      },
      {
        name: "book_close_date",
        label: "Book Close Date",
        field: "book_close_date",
        align: "center",
      },
    ];

    const pagination = ref({
      rowsPerPage: 10,
    });

    onMounted(() => {
      getBonusData(props.symbol);
    });

    watch(props, (newProps, oldProps) => {
      getBonusData(newProps.symbol);
    });

    return {
      bonusData,
      tableBonusData,
      tableRightData,
      columnsBonus,
      columnsRight,
      pagination,
    };
  },
};
</script>
